import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const OneFiveThreeToOneEightThree = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>153</Td>
          <Td>2 พงษ์กษัตริย์ 13,14</Td>
          <Td>2 โครินธ์ 6</Td>
          <Td>2 Kings 13,14</Td>
          <Td>2 Corinthians 6</Td>

          <Td>เลิกทำบาปเสีย</Td>
        </tr>
        <tr>
          <Td>154</Td>
          <Td>2 พงษ์กษัตริย์ 15,16</Td>
          <Td>สดุดี 64,65</Td>
          <Td>2 Kings 15,16</Td>
          <Td>Psalms 64,65</Td>

          <Td>วันคืนเก่าๆ ที่ดี</Td>
        </tr>
        <tr>
          <Td>155</Td>
          <Td>2 พงษ์กษัตริย์ 17,18</Td>
          <Td>2 โครินธ์ 7</Td>
          <Td>2 Kings 17,18</Td>
          <Td>2 Corinthians 7</Td>

          <Td>จัดการกับการไม่ยอมรับ</Td>
        </tr>
        <tr>
          <Td>156</Td>
          <Td>2 พงษ์กษัตริย์ 19,20</Td>
          <Td>2 โครินธ์ 8</Td>
          <Td>2 Kings 19,20</Td>
          <Td>2 Corinthians 8</Td>

          <Td>ฟังฉันพูด</Td>
        </tr>
        <tr>
          <Td>157</Td>
          <Td>2 พงษ์กษัตริย์ 21,22</Td>
          <Td>2 โครินธ์ 9</Td>
          <Td>2 Kings 21,22</Td>
          <Td>2 Corinthians 9</Td>

          <Td>ทำตามพระคัมภีร์</Td>
        </tr>
        <tr>
          <Td>158</Td>
          <Td>2 พงษ์กษัตริย์ 23-25</Td>
          <Td>สดุดี 66,67</Td>
          <Td>2 Kings 23-25</Td>
          <Td>Psalms 66,67</Td>

          <Td>เกียรติและความอาย</Td>
        </tr>
        <tr>
          <Td>159</Td>
          <Td>
            1 พงศาวดาร
            <br />
            1-3
          </Td>
          <Td>2 โครินธ์ 10</Td>
          <Td>1 Chronicles 1-3</Td>
          <Td>2 Corinthians 10</Td>

          <Td>บุตรชายหญิง</Td>
        </tr>
        <tr>
          <Td>160</Td>
          <Td>
            1 พงศาวดาร
            <br />
            4-6
          </Td>
          <Td>2 โครินธ์ 11</Td>
          <Td>1 Chronicles 4-6</Td>
          <Td>2 Corinthians 11</Td>

          <Td>ครอบครัว</Td>
        </tr>
        <tr>
          <Td>161</Td>
          <Td>
            1 พงศาวดาร
            <br />
            7-10
          </Td>
          <Td>สดุดี 68</Td>
          <Td>1 Chronicles 7-10</Td>
          <Td>Psalms 68</Td>

          <Td>ไม่ว่าอะไรจะเกิดขึ้น</Td>
        </tr>
        <tr>
          <Td>162</Td>
          <Td>
            1 พงศาวดาร
            <br />
            11-14
          </Td>
          <Td>2 โครินธ์ 12</Td>
          <Td>1 Chronicles 11-14</Td>
          <Td>2 Corinthians 12</Td>

          <Td>ชื่อเสียง?</Td>
        </tr>
        <tr>
          <Td>163</Td>
          <Td>
            1 พงศาวดาร
            <br />
            15,16
          </Td>
          <Td>2 โครินธ์ 13</Td>
          <Td>1 Chronicles 15,16</Td>
          <Td>2 Corinthians 13</Td>

          <Td>เดินต่อไป</Td>
        </tr>
        <tr>
          <Td>164</Td>
          <Td>
            1 พงศาวดาร
            <br />
            17,18
          </Td>
          <Td>กาลาเทีย 1</Td>
          <Td>1 Chronicles 17,18</Td>
          <Td>Galatians 1</Td>

          <Td>ประทับตรารับรอง</Td>
        </tr>
        <tr>
          <Td>165</Td>
          <Td>
            1 พงศาวดาร
            <br />
            19-21
          </Td>
          <Td>สดุดี 69</Td>
          <Td>1 Chronicles 19-21</Td>
          <Td>Psalms 69</Td>

          <Td>ล้นถึงคอแล้ว</Td>
        </tr>
        <tr>
          <Td>166</Td>
          <Td>
            1 พงศาวดาร
            <br />
            22,23
          </Td>
          <Td>กาลาเทีย 2</Td>
          <Td>1 Chronicles 22,23</Td>
          <Td>Galatians 2</Td>

          <Td>เหมาะสมกับงาน</Td>
        </tr>
        <tr>
          <Td>167</Td>
          <Td>
            1 พงศาวดาร
            <br />
            24-27
          </Td>
          <Td>กาลาเทีย 3</Td>
          <Td>1 Chronicles 24-27</Td>
          <Td>Galatians 3</Td>

          <Td>ลงชื่อเพื่อรับใช้</Td>
        </tr>
        <tr>
          <Td>168</Td>
          <Td>
            1 พงศาวดาร
            <br />
            28,29
          </Td>
          <Td>สดุดี 70,71</Td>
          <Td>1 Chronicles 28,29</Td>
          <Td>Psalms 70,71</Td>

          <Td>แบ่งเบาภาระกัน</Td>
        </tr>
        <tr>
          <Td>169</Td>
          <Td>
            2 พงศาวดาร
            <br />
            1,2
          </Td>
          <Td>กาลาเทีย 4</Td>
          <Td>2 Chronicles 1,2</Td>
          <Td>Galatians 4</Td>

          <Td>ตามรอยพ่อ</Td>
        </tr>
        <tr>
          <Td>170</Td>
          <Td>
            2 พงศาวดาร <br />
            3-5
          </Td>
          <Td>กาลาเทีย 5</Td>
          <Td>2 Chronicles 3-5</Td>
          <Td>Galatians 5</Td>

          <Td>พระนิเวศพระเจ้า</Td>
        </tr>
        <tr>
          <Td>171</Td>
          <Td>2 พงศาวดาร 6,7</Td>
          <Td>กาลาเทีย 6</Td>
          <Td>2 Chronicles 6,7</Td>
          <Td>Galatians 6</Td>

          <Td>ขอทรงฟังคำอธิษฐาน</Td>
        </tr>
        <tr>
          <Td>172</Td>
          <Td>2 พงศาวดาร 8,9</Td>
          <Td>สดุดี 72</Td>
          <Td>2 Chronicles 8,9</Td>
          <Td>Psalms 72</Td>

          <Td>ขอทรงพระเจริญ</Td>
        </tr>
        <tr>
          <Td>173</Td>
          <Td>
            2 พงศาวดาร
            <br />
            10-12
          </Td>
          <Td>เอเฟซัส 1</Td>
          <Td>2 Chronicles 10-12</Td>
          <Td>Ephesians 1</Td>

          <Td>การอภัยโทษ</Td>
        </tr>
        <tr>
          <Td>174</Td>
          <Td>2 พงศาวดาร 13-15</Td>
          <Td>เอเฟซัส 2</Td>
          <Td>2 Chronicles 13-15</Td>
          <Td>Ephesians 2</Td>

          <Td>ในพระคริสต์</Td>
        </tr>
        <tr>
          <Td>175</Td>
          <Td>2 พงศาวดาร 16,17</Td>
          <Td>สดุดี 73</Td>
          <Td>2 Chronicles 16,17</Td>
          <Td>Psalms 73</Td>

          <Td>อย่าสูญเสียความเชื่อ</Td>
        </tr>
        <tr>
          <Td>176</Td>
          <Td>2 พงศาวดาร 18-20</Td>
          <Td>เอเฟซัส 3</Td>
          <Td>2 Chronicles 18-20</Td>
          <Td>Ephesians 3</Td>

          <Td>ไม่เป็นความลับ</Td>
        </tr>
        <tr>
          <Td>177</Td>
          <Td>2 พงศาวดาร 21-23</Td>
          <Td>เอเฟซัส 4</Td>
          <Td>2 Chronicles 21-23</Td>
          <Td>Ephesians 4</Td>

          <Td>เก่าและใหม่</Td>
        </tr>
        <tr>
          <Td>178</Td>
          <Td>2 พงศาวดาร 24,25</Td>
          <Td>เอเฟซัส 5</Td>
          <Td>2 Chronicles 24,25</Td>
          <Td>Ephesians 5</Td>

          <Td>ควบคุมโดย...</Td>
        </tr>
        <tr>
          <Td>179</Td>
          <Td>2 พงศาวดาร 26-28</Td>
          <Td>สดุดี 74</Td>
          <Td>2 Chronicles 26-28</Td>
          <Td>Psalms 74</Td>

          <Td>ป้องกันและปลดปล่อย</Td>
        </tr>
        <tr>
          <Td>180</Td>
          <Td>2 พงศาวดาร 29-30</Td>
          <Td>เอเฟซัส 6</Td>
          <Td>2 Chronicles 29,30</Td>
          <Td>Ephesians 6</Td>

          <Td>ยืนหยัดอย่างมั่นคง</Td>
        </tr>
        <tr>
          <Td>181</Td>
          <Td>2 พงศาวดาร 31,32</Td>
          <Td>ลูกา 1:1-38</Td>
          <Td>2 Chronicles 31,32</Td>
          <Td>Luke 1:1-38</Td>

          <Td>ความจริงเปิดเผย</Td>
        </tr>
        <tr>
          <Td>182</Td>
          <Td>2 พงศาวดาร 33,34</Td>
          <Td>สดุดี 75,76</Td>
          <Td>2 Chronicles 33,34</Td>
          <Td>Psalms 75,76</Td>

          <Td>วันนี้ในอดีต</Td>
        </tr>
        <tr>
          <Td>183</Td>
          <Td>2 พงศาวดาร 35,36</Td>
          <Td>ลูกา 1:39-80</Td>
          <Td>2 Chronicles 35,36</Td>
          <Td>Luke 1:39-80</Td>

          <Td>สัญญาเป็นจริง</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default OneFiveThreeToOneEightThree;
